import React, { useContext, useEffect, useState } from 'react'
import jwt_decode from "jwt-decode";
import axios from 'axios';
import BaseURL from '../Utilities/BaseUrl';
import Loading from '../Loading/Loading';
import {cartContext}from'../Contexts/CartContext';
import { Helmet } from 'react-helmet';
function UserOrders() {
  let{setcheck}=useContext(cartContext);
     const [myItems, setmyItems] = useState([])

    function getUserOrders() {
        let {id}=jwt_decode(localStorage.getItem('token'));
        axios.get(`${BaseURL}orders/user/${id}`).then((data)=>{
             
      
         
           setmyItems(data.data)
           setcheck(true);
        
        }).catch((error)=>{console.log(error);})
    }
    useEffect(() => {
      
       setcheck(false);
      getUserOrders();
      
    }, [])
    
  return <>
  <Helmet>
        <title>allorders</title>
        
    </Helmet>
     {myItems.length>0? <div className="container mt-5 pt-5 pb-5">
        
        <div className="row">
            <div className="orders  pt-5">
                <div className="col-12">
                   
                <table>
            <thead><tr><th className='p-2'>Product</th>
                <th className='p-2'>Name</th>
                <th className='p-2'>Count</th>
                <th className='p-2'>Price</th>
                <th className='p-2'>Delivered</th>
                <th className='p-2'>Paid</th>
                <th className='p-2'>paymentType</th>
                <th className='p-2'>Created Date</th>
                </tr></thead>
                {myItems.map((item,index)=>{return <tbody key={index} >
               
              <tr>
                    <td className='p-2'> <img src={item.cartItems[0].product.imageCover} style={{width:100,height:80}}  /></td>
                    <td className='p-2'><span className=''>{item.cartItems[0].product.title.split(' ').slice(0,2).join(' ')}</span></td>
                    <td className='p-2'> <span className=''>{item.cartItems[0].count}</span></td>
                    <td className='p-2'> <span className=''>{item.cartItems[0].price} EGP</span></td>
                    <td className='p-2'> <span className=''>{item.isDelivered?'Completed':'Pending'}</span></td>
                    <td className='p-2'> <span className=''>{item.isPaid?'Paid':'notPaid'}</span></td>
                    <td className='p-2'> <span className=''>{item.paymentMethodType}</span></td>
                    <td className='p-2'> <span className=''>{item.createdAt}</span></td>
                    </tr>
                </tbody>})}
                </table></div>
            </div>
        </div>
      </div>:<Loading/>}
  </>
}

export default UserOrders
